var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "E/\\uFFFD1\\uFFFD*_3'2E'F_G'",
    "data-name": "E/\\uFFFD1\\uFFFD* 3'2E'F G'",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,0H32V32H0Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Building-Top",
    d: "M3,4.5A1.5,1.5,0,0,1,4.5,3h7A1.5,1.5,0,0,1,13,4.5V7H11V5H5V14H3Z",
    transform: "translate(2 2)",
    fill: "#333",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Building-Bottom",
    d: "M2,9H14a1,1,0,0,1,1,1V27a1,1,0,0,1-1,1H2a1,1,0,0,1-1-1V10A1,1,0,0,1,2,9Zm2,3v2H6V12Zm0,4v2H6V16Zm0,4v2H6V20Zm5-8v2h2V12Zm0,4v2h2V16Zm0,4v2h2V20ZM9,24h4v4H9Z",
    transform: "translate(7 0)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizations);
export default __webpack_public_path__ + "static/media/organizations.e462c3d4c237863d6289383048506bb8.svg";
export { ForwardRef as ReactComponent };